import { LngLatLike, useMap } from 'react-map-gl/mapbox';
import { INITIAL_VIEW_STATE } from '../constants/map';

export function useMapActions() {
  const { map } = useMap();

  const zoomTo = (position: LngLatLike, zoom: number = 16) => {
    map?.flyTo({
      zoom: INITIAL_VIEW_STATE.zoom < zoom ? zoom : INITIAL_VIEW_STATE.zoom,
      center: position,
      duration: 1500,
      essential: true,
    });
  };

  return { zoomTo };
}
